import Vue from 'vue'
import Vuex from 'vuex'

//import productList from './modules/productList'

Vue.use(Vuex)

// state
const state = {
    barIndex: 0, //记录底部菜单栏点击状态
    scrollTop: 0, //记录页面滚动距离，用在首页加载allApp页时
    routerTabs: [], //动态路由
    fullScreen: false, //横屏全屏页面
    showBar: { head: true, foot: true },
    labelParams: '', //标签-搜索的参数
    tbkey: '', //标签-切换tabs的参数
    //entryPath: location.hash.split('?')[0].slice(1), //入口路径，不会变
}

// getters
const getters = {
    barIndex: (state, getters) => {
        return state.barIndex
    },
    scrollTop: (state, getters) => {
        return state.scrollTop
    },
    routerTabs: (state, getters) => {
        return state.routerTabs
    },
    fullScreen: (state, getters) => {
        return state.fullScreen
    },
    showBar: (state, getters) => {
        return state.showBar
    },
    labelParams: (state, getters) => {
        return state.labelParams
    },
    tbkey: (state, getters) => {
        return state.tbkey
    }
}

// actions
const actions = {
    setBarIndex({ commit }, index) {
        commit('SET_BARINDEX', index)
    },
    setScrollTop({ commit }, index) {
        commit('SET_SCROLLTOP', index)
    },
    setRouterTabs({ commit }, index) {
        commit('SET_ROUTERTABS', index)
    },
    setFullScreen({ commit }, index) {
        commit('SET_FULLSCREEN', index)
    },
    setShowBar({ commit }, index) {
        commit('SET_SHOWBAR', index)
    },
    setLabelParams({ commit }, index) {
        commit('SET_LABELPARAMS', index)
    },
    setTbKey({ commit }, index) {
        commit('SET_TBKEY', index)
    },
};

// mutations
const mutations = {
    SET_BARINDEX(state, index) {
        state.barIndex = index
    },
    SET_SCROLLTOP(state, index) {
        state.scrollTop = index
    },
    SET_ROUTERTABS(state, index) {
        state.routerTabs = index
    },
    SET_FULLSCREEN(state, index) {
        state.fullScreen = index
    },
    SET_SHOWBAR(state, index) {
        state.showBar = index
    },
    SET_LABELPARAMS(state, index) {
        state.labelParams = index
    },
    SET_TBKEY(state, index) {
        state.tbkey = index
    },
}

export default new Vuex.Store({
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    //modules: {
    //productList,
    //},
})
